import React from "react";
import "../../App.css";
import ReactPlayer from "react-player";

function Rsgroup() {
  return (
    <div className="reel">
      <>
        <ReactPlayer
          url="https://www.youtube.com/watch?v=mp9SmbrKLqo"
          width="100%"
          height="100%"
          controls={true}
        />
      </>
    </div>
  );
}

export default Rsgroup;
